module.exports = __webpack_public_path__ + "img/pic-21.cd7eaf9e.jpg";